(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('input', function(event) {
  var range = event.target.closest('[data-comparison-range]');
  if (!range) return;
  var comparison = range.closest('[data-comparison]');
  if (comparison) comparison.style.setProperty('--split', range.value + '%');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-results"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-test-document-open]');
    if (openButton) {
      var dialog = document.getElementById(openButton.getAttribute('data-test-document-open'));
      if (dialog && dialog.showModal) dialog.showModal();
      return;
    }

    var closeButton = event.target.closest('[data-test-document-close]');
    if (closeButton) {
      var activeDialog = closeButton.closest('dialog');
      if (activeDialog) activeDialog.close();
    }
  });

  document.addEventListener('click', function (event) {
    if (event.target.tagName === 'DIALOG') event.target.close();
  });

  } catch(e) { console.error(e); }
})();
})();
